<template>
    <div class="research-form-container" v-loading="loading">
      <div class="form-header">
        <h2>Statement of Research Interest</h2>
        <p class="subtitle">Total length requirement: ~1000 words</p>
      </div>
  
      <el-form 
        :model="formData" 
        :rules="rules" 
        ref="researchForm" 
        label-position="top"
        size="medium"
      >
        
        <!-- 1. Personal Inspiration -->
        <el-form-item prop="inspiration">
          <span slot="label" class="custom-label">
            1. Personal Inspiration <small>(~300 words)</small>
          </span>
          <div class="label-tip">Explain why you would like to do research work and explore the beauty of science. Include previous research experience.</div>
          <el-input 
            type="textarea" 
            v-model="formData.inspiration" 
            :rows="6"
            placeholder="Write your inspiration here..."
            maxlength="2500" 
            show-word-limit
          ></el-input>
        </el-form-item>
  
        <!-- 2. Research Proposal -->
        <el-form-item prop="proposal">
          <span slot="label" class="custom-label">
            2. Research Proposal <small>(~500 words)</small>
          </span>
          <div class="label-tip">Emphasize the research directions and briefly introduce your proposal.</div>
          <el-input 
            type="textarea" 
            v-model="formData.proposal" 
            :rows="10"
            placeholder="Detail your research proposal here..."
            maxlength="4000"
            show-word-limit
          ></el-input>
        </el-form-item>
  
        <!-- 3. Choosing University -->
        <el-form-item prop="universityChoice">
          <span slot="label" class="custom-label">
            3. Choosing ** University <small>(~100 words)</small>
          </span>
          <div class="label-tip">Explain why you would like to study at this specific university.</div>
          <el-input 
            type="textarea" 
            v-model="formData.universityChoice" 
            :rows="4"
            placeholder="Reasons for choosing this university..."
            maxlength="1000"
            show-word-limit
          ></el-input>
        </el-form-item>
  
        <!-- 4. Conclusion -->
        <el-form-item prop="conclusion">
          <span slot="label" class="custom-label">
            4. Conclusion <small>(~100 words)</small>
          </span>
          <el-input 
            type="textarea" 
            v-model="formData.conclusion" 
            :rows="4"
            placeholder="Final concluding remarks..."
            maxlength="1000"
            show-word-limit
          ></el-input>
        </el-form-item>
  
        <!-- 底部按钮 -->
        <!-- <div class="form-footer">
          <el-button type="primary" @click="submitForm('researchForm')" icon="el-icon-s-promotion">Submit Statement</el-button>
          <el-button @click="resetForm('researchForm')" icon="el-icon-refresh-left">Reset</el-button>
        </div> -->
      </el-form>
      <HBFixedButton desc="_" @click="submitForm('researchForm')"/>
    </div>
  </template>
  
  <script>
import HBFixedButton from "../HBCommon/HBFixedButton/HBFixedButton";
  import { getUserInfoApi,updateUserInfoApi } from '@/api/mycenter_studyabroad.js';
  export default {
    name: 'ResearchInterestForm',
    components: {
      HBFixedButton
    },
    data() {
      return {
        loading:false,
        type:'phd_2',
        // 参数绑定
        formData: {
          inspiration: '',      // Part 1
          proposal: '',         // Part 2
          universityChoice: '', // Part 3
          conclusion: ''        // Part 4
        },
        // 校验规则
        rules: {
          inspiration: [
            { required: true, message: 'Please enter your personal inspiration', trigger: 'blur' }
          ],
          proposal: [
            { required: true, message: 'Please detail your research proposal', trigger: 'blur' }
          ],
          universityChoice: [
            { required: true, message: 'Please explain why you chose this university', trigger: 'blur' }
          ],
          conclusion: [
            { required: true, message: 'Please write a conclusion', trigger: 'blur' }
          ]
        }
      };
    },
    mounted() {
    this.requestGetUserInfo();
  },
    methods: {
      requestSubmitUserInfo() {
      let params = {
        type: this.type,
        user_id: this.$route.query.userId,
        data:{
          ...this.formData
        }
      };
      updateUserInfoApi(params).then(res => {
        if (res && res.code === 200) {
          this.$message.success('信息提交成功');
          window.location.reload();
        }
      }).catch(err => {
        console.error('提交用户信息失败:', err);
        this.$message.error(err.message || '提交用户信息失败');
      });
    },
    requestGetUserInfo() {
      let params = {
        type: this.type,
        user_id: this.$route.query.userId
      };
      this.loading = true;
      getUserInfoApi(params).then(res => {
        if (res && res.code === 200) {
          let data = {}
          try {
            if (res.data && res.data.raw_data) {
              data = JSON.parse(res.data.raw_data);
            }
          } catch (e) {
          }

          this.formData = {
            inspiration: data.inspiration || '',
            proposal: data.proposal || '',
            universityChoice: data.universityChoice || '',
            conclusion: data.conclusion || '',
          };
        }

      }).catch(err => {
        console.error('获取用户信息失败:', err);
        this.$message.error(err.message || '获取用户信息失败');
      }).finally(() => {
        this.loading = false;
      });
    },
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // 模拟提交
            this.$confirm('Confirm to submit your statement?', 'Submission', {
              confirmButtonText: 'Submit',
              cancelButtonText: 'Cancel',
              type: 'warning'
            }).then(() => {
              // console.log('Submitted Data:', this.formData);
              // this.$message.success('Statement submitted successfully!');
              // 这里写后端接口调用逻辑
              this.requestSubmitUserInfo();
            }).catch(() => {});
          } else {
            this.$message.error('Please complete all required fields.');
            return false;
          }
        });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    }
  };
  </script>
  
  <style scoped>
  .research-form-container {
    max-width: 900px;
    margin: 30px auto;
    padding: 40px;
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
    border: 1px solid #ebeef5;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
  }
  
  .form-header {
    border-bottom: 2px solid #409EFF;
    margin-bottom: 30px;
    padding-bottom: 15px;
  }
  
  .form-header h2 {
    margin: 0;
    color: #303133;
    font-size: 24px;
  }
  
  .subtitle {
    color: #909399;
    margin-top: 8px;
    font-size: 14px;
    font-weight: bold;
  }
  
  /* 自定义标签样式 */
  .custom-label {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
  }
  
  .custom-label small {
    font-weight: normal;
    color: #E6A23C;
    margin-left: 5px;
  }
  
  /* 题目下方的提示文字 */
  .label-tip {
    font-size: 13px;
    color: #606266;
    line-height: 1.5;
    margin-bottom: 8px;
    background: #f4f4f5;
    padding: 8px 12px;
    border-radius: 4px;
  }
  
  .form-footer {
    margin-top: 40px;
    display: flex;
    justify-content: center; /* 按钮居中 */
    gap: 20px;
  }
  </style>


// WEBPACK FOOTER //
// src/components/mycenter_studyabroad/component/tab_phd_2.vue